import React from 'react';
import PropTypes from 'prop-types';

import Cleave from 'cleave.js/react';

const options = {
  numeral: true,
  numeralThousandsGroupStyle: 'thousand',
};

const CreditCardAmountField = ({ field, ...props }) => (
  <Cleave options={options} {...field} {...props} />
);

CreditCardAmountField.propTypes = {
  field: PropTypes.object.isRequired,
};

export default CreditCardAmountField;
